<Modal
    id="assign-to-modal-resource-information-id"
    bind:enabled
    {cancelText}
    {confirmText}
    scrollBody={true}
    {titleText}
    on:confirm
    on:cancel
>
    <div slot="body">{bodyText}</div>
</Modal>

<script>
    import Modal from "@itslearning/prometheus/assets/modals/Modal/v2/Modal.svelte";
    import i18n from "@its-ui/planner-common/i18n";

    export let enabled = false;
    export let cancelText = i18n.cancel;
    export let confirmText = i18n.assignToTerms.updateAndAssign;
    export let titleText = i18n.assignTo;
    export let bodyText = i18n.assignToTerms.assigningPlanCreatesNewFolder;
</script>
